module.exports = __webpack_public_path__ + "img/cloud.3e0f8670.png";